import { useTranslation } from "react-i18next";

const AgentRegistrationHelpTooltip = () => {
  const { t } = useTranslation();
  return (
    <>
      <p>{t("AgentRegistrationHelpTooltip-important-text")}</p>
      <br />
      <table className="border border-black">
        <thead>
          <tr>
            <th className="border border-black">
              {t("AgentRegistrationHelpTooltip-title-1")}
            </th>
            <th className="border border-black">
              {t("AgentRegistrationHelpTooltip-title-2")}
            </th>
            <th className="border border-black">
              {t("AgentRegistrationHelpTooltip-title-3")}
            </th>
            <th className="border border-black">
              {t("AgentRegistrationHelpTooltip-title-4")}
            </th>
            <th className="border border-black">
              {t("AgentRegistrationHelpTooltip-title-5")}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-1")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-2")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-3")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-4")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-5")}
            </td>
          </tr>

          <tr>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-6")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-7")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-8")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-9")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-10")}
            </td>
          </tr>

          <tr>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-11")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-12")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-13")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-14")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-15")}
            </td>
          </tr>

          <tr>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-16")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-17")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-18")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-19")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-20")}
            </td>
          </tr>

          <tr>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-21")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-22")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-23")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-24")}
            </td>
            <td className="border border-black">
              {t("AgentRegistrationHelpTooltip-label-25")}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      {t("AgentRegistrationHelpTooltip-dsc")}
    </>
  );
};
export default AgentRegistrationHelpTooltip;
